import { getItems } from "../../../api/repositories/suggestedCourses";

export default {
  async get_suggestedCourses({ commit }, { perPage, currentPage }) {
    try {
      const response = await getItems(perPage, currentPage);
      commit("SET_SUGGESTEDCOURSES", response);
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
};